(function() {
    'use strict';

    angular
        .module('app.tiposPlanilla')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/tipos-planilla',
                config: {
                    templateUrl: 'app/tiposPlanilla/tiposPlanilla.html',
                    controller: 'TiposPlanilla',
                    controllerAs: 'vm',
                    title: 'TiposPlanilla'
                }
            },
            {
                url: '/editar-tipo-planilla/:id?',
                config: {
                    templateUrl: 'app/tiposPlanilla/editarTipoPlanilla.html',
                    controller: 'EditarTipoPlanilla',
                    controllerAs: 'vm',
                    title: 'EditarTipoPlanilla'
                }
            }
        ];
    }
})();
